module.exports = __webpack_public_path__ + "media/images/niq-reset-d877fadd483a87f39b10a97cdfb6f687.png";